export default __webpack_public_path__ + "static/media/greenscreen.ea20576a.jpg";